import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, XAxis, YAxis } from 'recharts'
import { Colors } from '@kvika/audur-theme'

import { TranslatedStrings } from '../../../utils/translations/TranslatedStrings'

import styles from './newCalculatorContainers.module.scss'

type INewCalculatorChartProps = {
	dataReduction: {
		year: number
		value: number
	}[]
	dataEqualization: {
		year: number
		value: number
	}[]
}

const NewCalculatorChart = (props: INewCalculatorChartProps) => {
	const { dataReduction, dataEqualization } = props
	const data = dataReduction
		.map((item) => {
			const equalizationItem = dataEqualization.find((eq) => eq.year === item.year)
			return {
				year: item.year,
				reduction: item.value,
				equalization: equalizationItem?.value || 0,
			}
		})
		.filter((_, index, arr) => {
			if (arr.length <= 20) return true
			return index % 2 === 0
		})

	return (
		<div className={styles.chartContainer}>
			<div className={styles.chartTitle}>{TranslatedStrings.is.newCalculator.monthlyInstallment}</div>
			<ResponsiveContainer width='100%' height={400}>
				<BarChart data={data} margin={{ top: 20, right: 0, left: 20, bottom: 10 }} barGap={8} barCategoryGap={40}>
					<CartesianGrid strokeDasharray='2' vertical={false} stroke='#BEB8C4' />
					<XAxis
						dataKey='year'
						tickLine={false}
						axisLine={{ strokeDasharray: '2', stroke: '#BEB8C4' }}
						tick={{ fontSize: 12, color: '#DBDBDB', fill: '#DBDBDB', fontWeight: 400, opacity: 0.8, dy: 13 }}
						tickFormatter={(value, index) => (index % 2 === 0 ? value : '')}
					/>
					<YAxis
						tickCount={6}
						axisLine={false}
						tickLine={false}
						tick={{
							fontSize: 12,
							color: '#DBDBDB',
							fill: '#DBDBDB',
							opacity: 0.8,
							fontWeight: 400,
							dx: -70,
							dy: -3,
							width: 100,
							textAnchor: 'start',
						}}
						tickFormatter={(value) => {
							const millions = (value / 1_000_000).toFixed(0)
							return `${millions} m.kr.`
						}}
					/>
					<Legend verticalAlign='top' align='right' />
					<Bar
						dataKey='equalization'
						name={TranslatedStrings.is.newCalculator.equalization}
						fill={Colors.Green}
						barSize={9}
					/>
					<Bar
						dataKey='reduction'
						name={TranslatedStrings.is.newCalculator.reduction}
						fill={Colors.LightOrange}
						barSize={9}
					/>
				</BarChart>
			</ResponsiveContainer>
		</div>
	)
}

export default NewCalculatorChart
